import { forwardRef, useEffect, createElement } from 'react';
import FinnMapElement from '@finn-no/finn-map';

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var FinnMap = /*#__PURE__*/forwardRef(function (_ref, forwardedRef) {
  var attributionPosition = _ref.attributionPosition,
      className = _ref.className,
      isStatic = _ref.static,
      props = _objectWithoutPropertiesLoose(_ref, ["attributionPosition", "className", "initialBounds", "static"]);

  // Wait until after rehydration to register the custom element
  useEffect(function () {
    if (!window.customElements.get('finn-map')) {
      window.customElements.define('finn-map', FinnMapElement);
    }
  }, []);
  return createElement("finn-map", Object.assign({}, props, {
    "attribution-position": attributionPosition,
    // className doesn't work on custom elements in React
    // @ts-ignore
    class: className,
    static: isStatic != null ? isStatic : undefined,
    ref: forwardedRef
  }));
});

export default FinnMap;
//# sourceMappingURL=finn-map-react.esm.js.map
